import { extendDefaultTheme } from './defaultTheme'

export default extendDefaultTheme({
  name: 'Brandie default'
})
